import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
// Copyright 2017-2022 @polkadot/api authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, isUndefined } from '@polkadot/util';

function sig(_ref, _ref2, args) {
  var lookup = _ref.lookup;
  var method = _ref2.method,
      section = _ref2.section;
  return "".concat(section, ".").concat(method, "(").concat(args.map(function (a) {
    return lookup.getTypeDef(a).type;
  }).join(', '), ")");
} // sets up the arguments in the form of [creator, args] ready to be used in a storage
// call. Additionally, it verifies that the correct number of arguments have been passed


export function extractStorageArgs(registry, creator, _args) {
  var args = _args.filter(function (a) {
    return !isUndefined(a);
  });

  if (creator.meta.type.isPlain) {
    assert(args.length === 0, function () {
      return "".concat(sig(registry, creator, []), " does not take any arguments, ").concat(args.length, " found");
    });
  } else {
    var _creator$meta$type$as = creator.meta.type.asMap,
        hashers = _creator$meta$type$as.hashers,
        key = _creator$meta$type$as.key;
    var keys = hashers.length === 1 ? [key] : registry.lookup.getSiType(key).def.asTuple.map(function (t) {
      return t;
    });
    assert(args.length === keys.length, function () {
      return "".concat(sig(registry, creator, keys), " is a map, requiring ").concat(keys.length, " arguments, ").concat(args.length, " found");
    });
  } // pass as tuple


  return [creator, args];
}